module.exports = __webpack_public_path__ + "media/images/university_logos/University-of-Sheffield-93eaa9fa4eecc285007dc267ccc2efc5.svg";